const colorNames = {
   blueDark: '#1A2D46',
   white: '#FFFFFF',
   light: '#EDEDED',
   greyLight: '#B9B9B9',
   grey: '#979797',
   plum: '#A74975',
   plumLight: '#f2e6ec',
   teal: '#035254',
   tealLight: '#dfe8e8',
   purple: '#31104e',
   purpleLight: '#e3e0e7',
   orange: '#E75236',
   orangeLight: '#fbe7e4',
   green: '#72D79D'
}

const colorUsages = {
   primary: colorNames.blueDark,
   background: colorNames.white,
   headline: colorNames.blueDark,
   text: colorNames.blueDark,
   button: colorNames.blueDark,
   disabledBg: colorNames.grey,
   disabledText: colorNames.greyLight,
   border: colorNames.grey,
   borderLight: colorNames.light,
   complement1: colorNames.plum, // 1st children color
   complement1Light: colorNames.plumLight,
   complement2: colorNames.teal, // 2nd children color
   complement2Light: colorNames.tealLight,
   complement3: colorNames.orange, // 3rd children color
   complement3Light: colorNames.orangeLight,
   complement4: colorNames.purple, // 4th children color
   complement4Light: colorNames.purpleLight,
   success: colorNames.green
}

export const color = {
   ...colorNames,
   ...colorUsages
}

export const fontBase = {
   regular: 'Roboto, sans-serif',
   lineHeight: '1.5',
   size: '18px'
}

export const fontSize = {
   base: '18px', //18px
   xs: '8px', //8px
   s: '12px', //12px
   sm: '16px', //16px
   m: '18px', //18px
   ml: '20px', //20px
   l: '24px', //24px
   xl: '28px', //28px
   xxl: '40px' //40px
}

export const spacing = {
   xs: '4px', //4px
   s: '8px', //8px
   sm: '10px', //10px
   m: '20px', //20px
   ml: '28px', //28px
   l: '40px', //40px
   xl: '50px', //50px
   xxl: '100px' //100px
}

export const shadow = {
   base: '0 2px 20px 0 rgba(212,212,212,0.5)'
}

export const width = {
   regularValue: '1130',
   regular: '1130px',
   narrowValue: '800',
   narrow: '800px'
}

export const breakpoint = {
   s: '600px',
   m: '800px',
   l: '1200px'
}

export const border = {
   radius: '5px'
}
